// 事務所の設定（数値と機能の ON / OFF）。変わったら即時に読み直す
import { useEffect, useState } from 'react';
import { DEFAULT_SETTINGS, type OfficeSettings } from '@torapon/shared';
import { api } from './api';
import { useLive } from './realtime';

export function useSettings() {
  const [s, setS] = useState<OfficeSettings>(DEFAULT_SETTINGS);
  const [loaded, setLoaded] = useState(false);
  const load = () => api.get<OfficeSettings>('/v1/office/settings').then((r) => { setS(r); setLoaded(true); }).catch(() => {});
  useEffect(() => { void load(); }, []);
  useLive(['settings'], load);
  return { settings: s, loaded, reload: load };
}
